// // // //client/src/pages/play/CapturePhoto.tsx
import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  useToast,
  Center,
  Spinner,
  Button,
  Flex,
  useBreakpointValue,
  HStack,
  useMediaQuery,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { uploadPhoto } from "../../utils/photoUpload";
import WebcamButton from "../../components/WebcamButton";

const MotionDiv = motion.div;

export default function CapturePhoto() {
  const [isUploading, setIsUploading] = useState(false);
  const [capturedPhoto, setCapturedPhoto] = useState<string | null>(null);
  const navigate = useNavigate();
  const toast = useToast();

  // Check if device is mobile
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const [isSmallHeight] = useMediaQuery("(max-height: 700px)");

  // Responsive values
  const headingSize = useBreakpointValue({
    base: "xl",
    sm: "2xl",
    md: "3xl",
    lg: "4xl",
  });
  const textSize = useBreakpointValue({ base: "md", sm: "lg", md: "xl" });
  const buttonSize = useBreakpointValue({ base: 'sm', md: 'md', lg: 'lg' }) as 'sm' | 'md' | 'lg';
  const spacing = useBreakpointValue({ base: 4, md: 6, lg: 8 });

  // Box dimensions - small before capture, larger after
  const boxWidth = capturedPhoto ? 
    useBreakpointValue({ base: "85%", sm: "80%", md: "75%", lg: "70%" }) : 
    useBreakpointValue({ base: "60%", sm: "55%", md: "50%", lg: "45%" });
  
  const boxHeight = capturedPhoto ? 
    useBreakpointValue({
      base: isSmallHeight ? "280px" : "320px",
      sm: "360px",
      md: "420px",
      lg: "480px",
    }) : 
    useBreakpointValue({
      base: "200px",
      sm: "220px",
      md: "240px",
      lg: "260px"
    });

  const handlePhotoCapture = async (photoUrl: string) => {
    setCapturedPhoto(photoUrl);
    toast({
      title: "Photo Captured",
      description: "Your photo has been captured successfully!",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  
    const handleProceedWithPhoto = async () => {
      if (!capturedPhoto) {
        toast({
          title: "No Photo",
          description: "Please capture a photo first or proceed without one.",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      try {
        setIsUploading(true);
        const response = await fetch(capturedPhoto);
        const blob = await response.blob();
        const result = await uploadPhoto(blob);
        navigate(`/play/quiz?userId=${result.userId}`);
      } catch (error) {
        const tempUserId = "temp_" + Math.random().toString(36).substring(2, 15);
        localStorage.setItem(`photo_${tempUserId}`, capturedPhoto);
        localStorage.setItem(`temp_user_${tempUserId}`, "true");
        navigate(`/play/quiz?userId=${tempUserId}`);
      } finally {
        setIsUploading(false);
      }
    };

    const handleProceedWithoutPhoto = async () => {
      try {
        setIsUploading(true);
        const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:5043/api";
        const response = await fetch(`${apiUrl}/user/create`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ photoUrl: "" }),
        });

        if (!response.ok) throw new Error("Failed to create user");
        const { userId } = await response.json();
        navigate(`/play/quiz?userId=${userId}`);
      } catch (error) {
        const tempUserId = "temp_" + Math.random().toString(36).substring(2, 15);
        localStorage.setItem(`temp_user_${tempUserId}`, "true");
        navigate(`/play/quiz?userId=${tempUserId}`);
      } finally {
        setIsUploading(false);
      }
    };

  return (
//     <Flex
//       minH="100vh"
//       w="100vw"
//       align="center"
//       justify="center"
//       overflowX="hidden"
//       position="relative"
//       px={4}
//     >
//       <VStack
//         spacing={spacing}
//         w="full"
//         maxW={{ base: "85%", sm: "80%", md: "75%", lg: "70%", xl: "800px" }}
//         mx="auto"
//         textAlign="center"
//         py={{ base: 8, md: 12, lg: 16 }}
//         px={{ base: 4, md: 6 }}
//         // bg="rgba(0, 0, 0, 0.6)"
//         // backdropFilter="blur(12px)"
//         // borderRadius="2xl"
//         // border="1px solid"
//         // borderColor="rgba(255,255,255,0.2)"
//         boxShadow="0 8px 32px rgba(0, 0, 0, 0.3)"
//         zIndex={1}
//          bg="rgba(0, 0, 0, 0)" // Semi-transparent dark overlay
//         backdropFilter="blur(8px)"
//         borderRadius="xl"
//         border="1px solid"
//         borderColor="rgba(255,255,255,0.1)"
//       >
//         <MotionDiv
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//         >
//           {/* <Heading
//             as="h1"
//             size={headingSize}
//             bgGradient="linear(to-r, purple.300, pink.300)"
//             bgClip="text"
//             mb={4}
//             lineHeight="1.2"
//             textShadow="0 2px 10px rgba(0,0,0,0.7)"
//             fontWeight="extrabold"
//           >
//             Capture Your Soul Mirror
//           </Heading> */}
//           <Heading
//   as="h1"
//   size={headingSize}
// bgGradient="linear(to-r, #A855F7, #E879F9)" // Even more vibrant  bgClip="text"
//   mb={4}
//   lineHeight="1.2"
//   fontWeight="extrabold"
//   sx={{
//     textShadow: `
//       0 1px 1px rgba(255,255,255,0.3),
//       0 2px 8px rgba(192, 132, 252, 0.4),
//       0 4px 12px rgba(236, 72, 153, 0.3)
//     `,
//     WebkitTextFillColor: 'transparent',
//     WebkitBackgroundClip: 'text',
//     backgroundClip: 'text'
//   }}
// >
//   Capture Your Soul Mirror
// </Heading>
//           {/* <Text
//             fontSize={textSize}
//             color="whiteAlpha.900"
//             fontWeight="medium"
//             textShadow="0 2px 4px rgba(0,0,0,0.7)"
//             maxW="2xl"
//             mx="auto"
//           >
//             Take a photo to begin your personalized archetype journey
//           </Text> */}
//           <Text
//   fontSize={textSize}
//   color="whiteAlpha.900"
//   fontWeight="medium"
//   textShadow="0 2px 4px rgba(0,0,0,0.7)"
//   maxW="2xl"
//   mx="auto"
//   mb={2}  // Added margin bottom to bring closer to the box
// >
//   Take a photo to begin your personalized archetype journey
// </Text>
//         </MotionDiv>

//         {/* <MotionDiv
//           initial={{ opacity: 0, scale: 0.95 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ delay: 0.3, duration: 0.8 }}
//           style={{ 
//             width: "100%",
//             display: "flex",
//             justifyContent: "center"
//           }}
//         >
//           <Box
//             w={boxWidth}
//             h={boxHeight}
//             borderRadius="2xl"
//             overflow="hidden"
//             boxShadow="2xl"
//             bg="rgba(255,255,255,0.15)"
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//             border="1px solid"
//             borderColor="rgba(255,255,255,0.2)"
//             p={4}
//             position="relative"
//             transition="all 0.3s ease-out"
//             _before={{
//               content: '""',
//               position: 'absolute',
//               inset: 0,
//               borderRadius: '2xl',
//               padding: '1px',
//               background: 'linear-gradient(135deg, rgba(192, 132, 252, 0.4), rgba(236, 72, 153, 0.4))',
//               WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
//               WebkitMaskComposite: 'xor',
//               maskComposite: 'exclude',
//             }}
//           >
//             {capturedPhoto ? (
//               <VStack spacing={6} w="full"> */}
//               <MotionDiv
//   initial={{ opacity: 0, scale: 0.95 }}
//   animate={{ opacity: 1, scale: 1 }}
//   transition={{ delay: 0.3, duration: 0.8 }}
//   style={{ 
//     width: "100%",
//     display: "flex",
//     justifyContent: "center"
//   }}
// >
//   <Box
//     w={capturedPhoto ? "85%" : "50%"}  // Reduced width
//     h={capturedPhoto ? "320px" : "180px"}  // Reduced height
//     borderRadius="2xl"
//     overflow="hidden"
//     boxShadow="xl"  // Changed from '2xl' to 'xl'
//     bg="rgba(255,255,255,0.15)"
//     display="flex"
//     alignItems="center"
//     justifyContent="center"
//     border="1px solid"
//     borderColor="rgba(255,255,255,0.2)"
//     p={2}  // Reduced padding
//     position="relative"
//     transition="all 0.3s ease-out"
//   >
//     {capturedPhoto ? (
//       <VStack spacing={4} w="full"> 
//                 <Box
//                   w="full"
//                   maxW={{ base: "280px", sm: "320px", md: "360px" }}
//                   h="auto"
//                   overflow="hidden"
//                   borderRadius="xl"
//                   boxShadow="xl"
//                   border="2px solid"
//                   borderColor="rgba(255,255,255,0.2)"
//                 >
//                   <img
//                     src={capturedPhoto}
//                     alt="Captured photo"
//                     style={{
//                       width: "100%",
//                       height: "auto",
//                       objectFit: "cover",
//                     }}
//                   />
//                 </Box>
//                 <HStack spacing={4} w="full" justify="center">
//                   <Button
//                     size={buttonSize}
//                     colorScheme="purple"
//                     onClick={handleProceedWithPhoto}
//                     isLoading={isUploading}
//                     loadingText="Processing..."
//                     px={8}
//                     _hover={{
//                       transform: "translateY(-2px)",
//                       boxShadow: "0 4px 12px rgba(159, 122, 234, 0.6)",
//                     }}
//                     transition="all 0.2s ease-out"
//                   >
//                     Continue with Photo
//                   </Button>
//                   <WebcamButton 
//                     onPhotoCapture={handlePhotoCapture} 
//                     buttonText="Retake Photo"
//                     buttonSize={buttonSize}
//                   />
//                 </HStack>
//               </VStack>
//             ) : (
//               // <VStack spacing={6} w="full">
//               //   <WebcamButton 
//               //     onPhotoCapture={handlePhotoCapture} 
//               //     buttonText="Take Photo"
//               //     buttonSize={buttonSize}
//               //   />
//               //   <Button
//               //     size={buttonSize}
//               //     variant="outline"
//               //     colorScheme="purple"
//               //     onClick={handleProceedWithoutPhoto}
//               //     isLoading={isUploading}
//               //     loadingText="Processing..."
//               //     _hover={{
//               //       transform: "translateY(-2px)",
//               //       boxShadow: "0 4px 12px rgba(159, 122, 234, 0.3)",
//               //     }}
//               //     transition="all 0.2s ease-out"
//               //   >
//               //     Skip Photo
//               //   </Button>
//               // </VStack>
//                <VStack spacing={4} w="full">  // Reduced spacing
//         <WebcamButton 
//           onPhotoCapture={handlePhotoCapture} 
//           buttonText="Take Photo"
//           buttonSize={buttonSize}
//         />
//         <Button
//           size={buttonSize}
//           variant="outline"
//           colorScheme="purple"
//           onClick={handleProceedWithoutPhoto}
//           isLoading={isUploading}
//           loadingText="Processing..."
//           _hover={{
//             transform: "translateY(-2px)",
//             boxShadow: "0 4px 12px rgba(159, 122, 234, 0.3)",
//           }}
//           transition="all 0.2s ease-out"
//           px={6}  // Reduced horizontal padding
//         >
//           Skip Photo
//         </Button>
//       </VStack>
//             )}
//           </Box>
//         </MotionDiv>
//       </VStack>

//       {isUploading && (
//         <Center
//           position="fixed"
//           top={0}
//           left={0}
//           right={0}
//           bottom={0}
//           bg="blackAlpha.800"
//           zIndex={999}
//           backdropFilter="blur(8px)"
//         >
//           <VStack spacing={6}>
//             <Spinner 
//               size="xl" 
//               color="purple.400" 
//               thickness="4px"
//               speed="0.8s"
//             />
//             <Text 
//               fontSize={{ base: "lg", md: "xl" }} 
//               color="white"
//               fontWeight="medium"
//             >
//               Preparing your journey...
//             </Text>
//           </VStack>
//         </Center>
//       )}
//     </Flex>
<Flex
  minH="100vh"
  w="100vw"
  align="center"
  justify="center"
  overflowX="hidden"
  position="relative"
  px={4}
>
  <VStack
    spacing={4} // Reduced spacing
    w="full"
    maxW={{ base: "90%", sm: "80%", md: "70%", lg: "60%", xl: "500px" }} // Smaller max width
            // maxW={{ base: "85%", sm: "80%", md: "75%", lg: "70%", xl: "800px" }}

    mx="auto"
    textAlign="center"
    py={{ base: 6, md: 8 }} // Reduced padding
    px={{ base: 4, md: 5 }}
    bg="rgba(0, 0, 0, 0)"
    backdropFilter="blur(8px)"
    borderRadius="xl"
    border="1px solid"
    borderColor="rgba(255,255,255,0.1)"
    boxShadow="0 8px 32px rgba(0, 0, 0, 0.3)"
    zIndex={1}
  >
    <MotionDiv
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <Heading
        as="h1"
        size={{ base: "xl", sm: "2xl" }} // Smaller heading size
        bgGradient="linear(to-r, purple.300, pink.300)"
        bgClip="text"
        mb={2} // Reduced margin
        lineHeight="1.2"
      >
        Capture Your Soul Mirror
      </Heading>
      <Text
        fontSize={{ base: "sm", sm: "md" }} // Smaller text size
        color="whiteAlpha.900"
        fontWeight="medium"
        mb={4} // Added margin bottom
      >
        Take a photo to begin your personalized archetype journey
      </Text>
    </MotionDiv>

    <MotionDiv
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.3, duration: 0.8 }}
      style={{ width: "100%" }}
    >
      <Box
        w="full"
        h="auto"
        minH="180px" // Smaller fixed height
        borderRadius="xl"
        bg="rgba(255,255,255,0.1)"
        border="1px solid"
        borderColor="rgba(255,255,255,0.2)"
        p={3} // Reduced padding
      >
        {capturedPhoto ? (
          <VStack spacing={3}>
            <Box
              w="full"
              maxW="280px"
              h="auto"
              mx="auto"
              borderRadius="lg"
              overflow="hidden"
            >
              <img
                src={capturedPhoto}
                alt="Captured photo"
                style={{ width: "100%", height: "auto" }}
              />
            </Box>
            <HStack spacing={3} justify="center">
              <Button
                size="sm" // Smaller button
                colorScheme="purple"
                onClick={handleProceedWithPhoto}
              >
                Continue with Photo
              </Button>
              <WebcamButton 
                onPhotoCapture={handlePhotoCapture} 
                buttonText="Retake"
                buttonSize="sm" // Smaller button
              />
            </HStack>
          </VStack>
        ) : (
          <VStack spacing={3}>
            <WebcamButton 
              onPhotoCapture={handlePhotoCapture} 
              buttonText="Take Photo"
              buttonSize="sm" // Smaller button
            />
            <Button
              size="sm" // Smaller button
              variant="outline"
              colorScheme="purple"
              onClick={handleProceedWithoutPhoto}
            >
              Skip Photo
            </Button>
          </VStack>
        )}
      </Box>
    </MotionDiv>
  </VStack>
</Flex>
  );
}